<template>
    <div class="header-container"
        :style="headerContainerStyle"
    >
        <a-row>
            <a-col
                :span="18"
                :xs="10"
            >   

                <HamburgerMenuComponent />
                <a-menu
                    v-show="false"
                    v-model="current"
                    mode="horizontal"
                    :style="{
                        lineHeight: '64px'
                    }"
                >   
                    <a-menu-item
                        key="folders"
                    >
                        <a-icon type="folder" />
                        Mappák
                    </a-menu-item>
                    <a-sub-menu
                        
                    >
                        <span 
                            slot="title"
                        >
                            <a-icon type="setting" />
                            Admin beállítások
                        </span>
                        <a-menu-item 
                            key="users"
                        >
                            Felhasználók kezelése
                        </a-menu-item>

                    </a-sub-menu>
                    <a-menu-item
                        key="scroll"
                    >
                        <a-icon type="pic-center" />
                        Scroll
                    </a-menu-item>
                </a-menu>
            </a-col>
            <a-col
                :span="6"
                :xs="14"
            >
                <div class="header-right-icons">
                    <SessionTimer />
                    <div class="icon-button"
                        v-if="getRoleAvaliable(['ROLE_ADVANCED_USER', 'ROLE_ADMIN'])"
                        :class="{active: fileSelectionsActive}"
                    >   
                        <span>
                        <a-badge
                            :count="fileSelections.count"
                        >
                            <a-icon
                                :style="{
                                    cursor: 'pointer',
                                    fontSize: '24px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    color: '#ffffff'
                                }"
                                type="database"
                                
                                v-on:click="switchFileSelectionsActive"
                            />
                        </a-badge>
                        </span>
                        <transition
                            name="file-uploads-transition"
                        >
                            <div 
                                v-if="fileSelectionsActive"
                                class="file-selections-drawer"
                                v-on:click="(e) => e.stopPropagation()"
                            >
                                <FileSelectionsComponent />
                            </div>
                        </transition>
                    </div>
                    <div class="icon-button"
                        :class="{active: fileDrawerActive}"
                    >   
                        <span>
                        <a-badge
                            :dot="filesDot.count > 0"
                            :count="filesDot.count"
                        >
                            <a-icon
                                :style="{
                                    cursor: 'pointer',
                                    fontSize: '24px',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                    color: '#ffffff'
                                }"
                                type="bell"
                                
                                v-on:click="switchFileDrawerActive"
                            />
                        </a-badge>
                        </span>
                        <transition
                            name="file-uploads-transition"
                        >
                            <div 
                                v-if="fileDrawerActive"
                                class="file-uploads-drawer"
                                v-on:click="(e) => e.stopPropagation()"
                            >
                                <FileProgressComponent />
                            </div>
                        </transition>
                    </div>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import FileProgressComponent from './FileProgressComponent.vue';
import FileSelectionsComponent from './FileSelectionsComponent.vue';
import HamburgerMenuComponent from './HamburgerMenuComponent.vue';
import SessionTimer from './SessionTimer.vue';


import tile1 from '@/assets/smb/tiles-01.svg';
import tile2 from '@/assets/smb/tiles-02.svg';
import tile3 from '@/assets/smb/tiles-03.svg';
import smb_rect from '@/assets/smb/smb_rect.svg';
import smb_circle from '@/assets/smb/smb_circle.svg';
import smb_triangle from '@/assets/smb/smb_triangle.svg';

export default {
    components: {
        FileProgressComponent,
        HamburgerMenuComponent,
        FileSelectionsComponent,
        SessionTimer
    },

    // mounted() {
    //     document.body.addEventListener('click',this.bodyClickHandler)
    // },

    data() {
        return {
            fileDrawerActive: false,
            fileSelectionsActive: false,
        }
    },

    created() {
        
    },

    computed: {
        current: {
            get() {
                if (this.$route.name) {
                    return [ `${this.$route.name}`]
                }
            },
            set(val) {
                this.$router.push({
                    name: val
                })
            }
        },

        headerContainerStyle() {

            // const sid = '1021';
            let sid = this.$store.state.user_module.sid;
            if (!sid) {
                sid = '1012';
            }

            const symbolMap = new Map([
                ['0', 'smb_circle'],
                ['1', 'smb_triangle'],
                ['2', 'smb_rect']
            ]);

            // const tilesUrls = {
            //     tile1: '~@/assets/smb/tiles-01.svg',
            //     tile2: '~@/assets/smb/tiles-02.svg',
            //     tile3: '~@/assets/smb/tiles-03.svg'
            // };

            // const symbolsUrls = {
            //     smb_circle: '~@/assets/smb/smb_circle.svg',
            //     smb_triangle: '~@/assets/smb/smb_triangle.svg',
            //     smb_rect: '~@/assets/smb/smb_rect.svg',
            // };
            const tilesUrls = {
                tile1,
                tile2,
                tile3
            };

            const symbolsUrls = {
                smb_circle,
                smb_triangle,
                smb_rect
            };

            const baseLeft = -35;
            const leftDistance = 25;
            const symbolHeight = 20;
            const symbolTop= 24;

            const bgImage = () => {
                let bgImageVal = `url(${tilesUrls.tile2})`;
                sid.split('').forEach(el => {
                    bgImageVal += `, url(${symbolsUrls[symbolMap.get(el)]})`;
                })
                return bgImageVal;
            };


            const bgPosition = () => {
                let bgPosVal = `0 0`;
                for (let i = 0; i <= sid.length; i++) {
                    bgPosVal += `, ${baseLeft + (leftDistance * i)}px ${symbolTop}px`;
                }
                return bgPosVal;
            };

            // const styles = {
            //     background-image: url('~@/assets/smb/tiles-01.svg'), url('~@/assets/smb/smb_circle.svg'), url('~@/assets/smb/smb_triangle.svg'), url('~@/assets/smb/smb_circle.svg'), url('~@/assets/smb/smb_rect.svg');
            //     background-repeat: repeat-x, repeat-x, repeat-x, repeat-x;
            //     background-size: 150px 67px, 150px 26px, 150px 26px, 150px 26px, 150px 26px;
            //     background-position: 0 0, -40px 22px, -15px 22px, 10px 22px, 35px, 22px;
            // }

            const styles = {
                backgroundImage: bgImage(),
                backgroundRepeat: 'repeat-x',
                backgroundSize: `150px 67px, 150px ${symbolHeight}px, 150px ${symbolHeight}px, 150px ${symbolHeight}px, 150px ${symbolHeight}px`,
                backgroundPosition: bgPosition()
            };
            return styles;
        },

        filesDot() {
            const uploadingFilesList = this.$store.getters.getUploadingFiles();

            let dotStatus = undefined;

            if (uploadingFilesList.length === 0) {
                return {
                    status: dotStatus,
                    count: 0
                }
            }

            if (uploadingFilesList.some(file => file.status === 'exception')) {
                dotStatus = 'error';
            } else if (uploadingFilesList.some(file => file.status === 'active')) {
                dotStatus = 'processing'
            } else {
                dotStatus = 'processing'
            }

            return {
                status: dotStatus,
                count: 1
            }
            
        },
        fileSelections() {
            const selectedInfos = this.$store.state.info_module.selectedInfos;

            return {
                count: selectedInfos.length
            }
        }
    },

    methods: {
        bodyClickHandler(e) {
             if (this.fileDrawerActive) {
                this.switchFileDrawerActive(e);
            }

            if (this.fileSelectionsActive) {
                this.switchFileSelectionsActive(e);
            }
        },
        
        switchFileDrawerActive(e) {
            e.preventDefault();
            e.stopPropagation();
            if (this.fileSelectionsActive) {
                this.switchFileSelectionsActive(e);
            }
            this.fileDrawerActive = !this.fileDrawerActive;
        },
        switchFileSelectionsActive(e) {
            e.preventDefault();
            e.stopPropagation();
             if (this.fileDrawerActive) {
                this.switchFileDrawerActive(e);
            }
            this.fileSelectionsActive = !this.fileSelectionsActive;
        },
        getRoleAvaliable(roles) {
            return this.$store.getters.getRoleAvaliable(roles);
        }
    }
}
</script>

<style lang="scss" scoped>
    .header-container {
        // background-image: url('~@/assets/smb/tiles-01.svg'), url('~@/assets/smb/smb_circle.svg'), url('~@/assets/smb/smb_triangle.svg'), url('~@/assets/smb/smb_circle.svg'), url('~@/assets/smb/smb_rect.svg');
        // background-repeat: repeat-x, repeat-x, repeat-x, repeat-x;
        // background-size: 150px 67px, 150px 26px, 150px 26px, 150px 26px, 150px 26px;
        // background-position: 0 0, -40px 22px, -15px 22px, 10px 22px, 35px, 22px;
    }
    .header-right-icons {
        display: flex;
        align-items: center;
        justify-content:flex-end;

        border-bottom: 1px solid #e8e8e8;

        .icon-button {
            display: flex;
            align-items:center;
            height: 100%;
            margin-right: 10px;
            // background-color: $primary-blue;
            position: relative;
            transition: background-color 0.2s ease-in-out;

            &:hover, &.active {
                background-color: rgba(255, 255, 255, 0.781);
            }
        }

        .file-uploads-drawer {
                position: absolute;
                top: 67px;
                left: -275px;
                max-width: 310px;
                min-width: 310px;
        }
        .file-selections-drawer {
            position: absolute;
                top: 67px;
                left: -275px;
                min-width: 310px;
                max-width: 310px;
        }
    }

    .file-uploads-transition-active, .file-uploads-transition-enter-active .file-uploads-transition-leave-active {
        transition: all 0.5s;
        transform-origin: 100% 0%;

    }
    .file-uploads-transition-enter, .file-uploads-transition-leave-to {
        transition: all 0.5s ;
        transform-origin: 100% 0%;
        transform: scale(0);
        opacity: 0;
    }
    .file-uploads-transition-enter-to {
        
        transition: all 0.5s ;
        opacity: 1;
        transform: scale(1);

    }
</style>
